module.exports = __webpack_public_path__ + "img/bb_g3_mouth-02.99af3fec.svg";